export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `44`, `46`, `48`, `50`, `52`, `54`, `56`],
  [`Плечи`, `42`, `43`, `44`, `45`, `46`, `47`, `48`],
  [`Грудь`, `48`, `50`, `52`, `54`, `56`, `58`, `60`],
  [`Длина`, `67`, `68`, `69`, `72`, `72`, `74`, `74`]
];
